import { render } from "./CGU.vue?vue&type=template&id=0db46cf4&scoped=true"
import script from "./CGU.vue?vue&type=script&lang=js"
export * from "./CGU.vue?vue&type=script&lang=js"

import "./CGU.vue?vue&type=style&index=0&id=0db46cf4&lang=css"
import "./CGU.vue?vue&type=style&index=1&id=0db46cf4&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db46cf4"]])

export default __exports__